import { Box, Typography, styled } from "@mui/material";
import "../PlayItem/PlayItem.css";
const PlayItem = ({ repeatRef, huda, setOpenBottomSheet, setHudaIndex, isSelected, newHudaList, hudaIndex, index, maxIndex }) => {
    const CoverImage = styled("div")({
        width: 30,
        height: 30,
        objectFit: "cover",
        overflow: "hidden",
        flexShrink: 0,
        borderRadius: 4,
        backgroundColor: "rgba(0,0,0,0.08)",
        "& > img": {
            width: "100%",
        },
        height: "inherit",
    });
    return (
        index <= maxIndex && (
            <div
                className={isSelected ? "play-item selected" : "play-item "}
                onClick={() => {
                    setOpenBottomSheet(false);
                    setHudaIndex(newHudaList.findIndex((e) => e === huda));
                    repeatRef.current = 0;
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", borderRadius: 1 }}>
                    <CoverImage>
                        <img alt="" src={huda.eHuda} />
                    </CoverImage>
                    <Box sx={{ ml: 1.5, minWidth: 0 }}>
                        <Typography variant="caption" color="text.secondary" fontWeight={500}>
                            {huda.gyou}
                        </Typography>
                        <Typography noWrap letterSpacing={-0.25}>
                            {huda.info}
                        </Typography>
                    </Box>
                </Box>
            </div>
        )
    );
};

export default PlayItem;
